import {articleHttpRepository} from '../../repositories/article-http-repository';
import {articleMemoryRepository} from '../../repositories/article-memory-repository';

export const readArticle = articleId =>
  articleHttpRepository.get(articleId)
    .then(article => {
      if (article) {
        articleMemoryRepository.set(article);
      }
      return article;
    });
